import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';

import Calendar from 'rc-calendar';
import ruRU from 'rc-calendar/lib/locale/ru_RU';
import enUS from 'rc-calendar/lib/locale/en_US';
import moment from 'moment';
import 'moment/locale/ru';
import TimePickerPanel from 'rc-time-picker/lib/Panel';

import { useOutsideClicker } from 'libs/hooks';
import { CalendarBox, DateInput, DateInputBox, InputBox } from './date-select.styled';

const timePickerElement = <TimePickerPanel defaultValue={moment('00:00:00', 'HH:mm')} />;
const timePickerElement2 = <TimePickerPanel defaultValue={moment('23:59:59', 'HH:mm')} />;

export const DateSelect = (props) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  /**
   * toggler open
   * @returns `
   */
  const toggle = () => setOpen(!open);

  /**
   * set date
   * @param {*} date
   */
  const setDate = (date) => {
    props.setFilter(props.fieldName, date);
  };

  /**
   * close on click outside
   */
  const ref = useRef(null);
  useOutsideClicker(ref, () => {
    setOpen(false);
  });

  const getDisplayedValue = () => {
    return props.value
      ? moment(props.value)
          .locale(i18n.language === 'ru' ? 'ru' : 'en')
          .format('lll')
          .replace(/[г., ]{4}/, '')
          .replace(/\./, '')
      : '';
  };

  const timeel = props.fieldName.indexOf('_to') === -1 ? timePickerElement : timePickerElement2;

  const calendarLocale = i18n.language === 'ru' ? ruRU : enUS;

  return (
    <InputBox ref={ref}>
      <DateInputBox onClick={toggle}>
        <DateInput
          value={getDisplayedValue()}
          mergedLeftInput={props.mergedLeftInput}
          mergedRightInput={props.mergedRightInput}
          placeholder={t('filters.Весь период')}
          name="date"
        />
      </DateInputBox>
      <div className="POPUP">
        <CalendarBox style={{ display: open ? 'block' : 'none' }}>
          <Calendar
            value={moment(props.value).locale(i18n.language === 'ru' ? 'ru' : 'en')}
            selectedValue={moment(props.value)}
            timePicker={timeel}
            onSelect={(date) => {
              setDate(date);
            }}
            onChange={(date) => {
              setDate(date);
            }}
            locale={calendarLocale}
            className={'calendar'}
            showDateInput={false}
          />
        </CalendarBox>
      </div>
    </InputBox>
  );
};
